import { useEffect, useState } from 'react';
import { SketchPicker } from 'react-color';
import { connect } from 'react-redux';
import * as d3 from 'd3';
import './css/InteractiveLegend.css';

const mapStateToProps = state => ({
    legendClicked: state.canvas.legendClicked,
});

function InteractiveLegend(props) {

    const [legend, setLegend] = useState(null);
    const [color, setColor] = useState("#fff");
    const [value, setValue] = useState(null);
    
    useEffect(() => {
        const l = props.legendClicked.legend, v = props.legendClicked.value;
        if (l && v) {
            d3.select("#legendColorPicker").style("visibility", "visible");
            setLegend(props.scene.getItem(l));
            setValue(v);
            setColor(props.scene.getItem(l).encoding.scale.map(v));
        } else {
            d3.select("#legendColorPicker").style("visibility", "hidden");
        }
    }, [props.legendClicked, props.scene])
    
    const changeCompleted = (c, e) => {
        setColor(c.hex);
        const domain = legend.encoding.scale.domain, range = [];
        for (let d of domain) {
            if (d === value)
                range.push(c.hex);
            else
                range.push(legend.encoding.scale.map(d));
        }
        legend.encoding.scale._setRange(range);
        props.renderer.render(props.scene);
    }

    return (
        <div id="legendColorPicker">
            <SketchPicker disableAlpha={true} color={color} onChangeComplete={changeCompleted}/>
        </div>
    )
}

export default connect(mapStateToProps)(InteractiveLegend);